import global from 'global';
import { merge } from 'lodash';

import Transport from './transport/IframeTransport';
import createBridge from './createBridge';
import { connect } from './connector';
import { GET_BRIDGE_DATA } from './actions';

let connected = false;
const connectDispatcher = (dispatcher, { mode }) => {
  if (connected) {
    return;
  }

  if (mode !== 'master') {
    if (global.parent === global) {
      throw new Error('Runs not in frame context');
    }

    const transport = new Transport(global.parent);

    connect(transport, dispatcher);
    transport.connect();
  }

  connected = true;
};

export default dispatcher => async (options) => {
  connectDispatcher(dispatcher, options);

  const bridgeData = {};

  const load = async () => {
    const { result } = await dispatcher.request(GET_BRIDGE_DATA);

    return merge(bridgeData, result);
  };

  return createBridge(await load(), dispatcher, load);
};



// WEBPACK FOOTER //
// ./src/WebBridge/resolver.js